module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?147e3378b44bc9570418b1eece10dd7c";